// Feature flags shim — contained mode: every estimating feature is ON.
// (The source app gates beta features per-account; the module enables
// the full surface by default.)

export function useFeatureFlags() {
  return {
    show_auto_pin: true,
    show_draw_takeoff: true,
  };
}
